import React from 'react';
import __ from 'lodash';

class DropdownTematik extends React.Component{
    render(){
        if(this.props.mapel != null){
            return (
                this.props.mapel.map((val, i) =>
                    <option key={i} value={val.idTematik}>{val.namaTematik}</option>
                )
            )
        }
    }
}

export default DropdownTematik;